export default {
  'app.org.title': 'Organizaciones',
  'app.org.column.id': 'ID de la organización',
  'app.org.column.name': 'Nombre de la organización',
  'app.org.column.timezone': 'Zona horaria',
  'app.org.column.website': 'Sitio web',
  'app.org.column.isCreator': '¿Es el creador?',
  'app.org.column.createTime': 'Fecha de creación',
  'app.org.column.operate': 'Operar',
  'app.org.column.operate.enter': 'Acceder',
  'app.org.column.operate.edit': 'Editar',
  'app.org.column.operate.delete': 'Eliminar',
  'app.org.column.operate.placeholder':
    'introduzca el nombre de la organización/ID de la organización',
  'app.org.create': 'Crear organización',
  'app.org.create.submit': 'Crear organización',
  'app.org.bind.tip': 'Crear nueva organización',
  'app.org.create.tip': '¿Ya tiene organización?',
  'app.org.create.tip.bind': 'Vincular',
  'app.org.success.tip': 'Volver a la consola',
  'app.org.bind': 'Finalizar vinculación',
  'app.org.bind.submit': 'Vinculación acabada',
  'app.Crear una organizaciónorg.create.create': 'Crear',
  'app.org.create.cancel': 'Cancelar',
  'app.org.create.save': 'Guardar',
  'app.org.create.profile': 'Información de la organización',
  'app.org.create.name.placeholder': 'Introduzca el nombre de la organización',
  'app.org.create.website.placeholder': 'Introduzca una URL (dominio de nivel superior)',
  'app.org.create.timezone': 'Zona horaria',
  'app.org.create.timezone.tip': '(La zona horaria no podrá modificarse después)',
  'app.org.create.currency': 'Moneda',
  'app.org.create.usd': 'USD',
  'app.org.create.success': 'Organización creada',
  'app.org.edit.success': 'Organización actualizada',
  'app.org.rule.blank': 'Este campo es obligatorio',
  'app.org.rule.char': 'No se permiten caracteres ilegales en el nombre del rol',
  'app.org.rule.name.exists': 'El nombre de la organización ya existe',
  'app.org.rule.url.exists': 'La URL ya existe',
  'app.org.rule.url.start': 'La URL debe comenzar con "www"',
  'app.org.delete.title': 'Eliminar organización',
  'app.org.delete.content':
    '¡Atención! La eliminación de su organización es irreversible. Se eliminarán permanentemente los datos y la información como usuarios, empresas, saldos, facturas, pedidos e intereses de esta organización, y todos los servicios relacionados se darán por terminados.',
  'app.org.delete.warn': 'No se puede eliminar la cuenta si hay que pagar un suplemento.',
  'app.org.delete.cancel': 'Cancelar',
  'app.org.delete.next': 'Siguiente',
  'app.org.delete.delete': 'Eliminar definitivamente',
  'app.org.delete.confirm': 'Confirmar eliminación',
  'app.org.delete.confirm.content':
    ' Para confirmar la eliminación:1. Revise su correo electrónico 2. Introduzca el código de verificación enviado',
  'app.org.delete.confirm.send': 'Enviar código de verificación',
  'app.org.delete.confirm.send.resend': 'Reenviar código de verificación',
  'app.org.delete.confirm.resend': 'Reenviar',
  'app.org.delete.confirm.rule': 'Por favor, introduzca la verificación correcta',
  'app.org.delete.success': 'Organización eliminada',
  'app.org.delete.balance': 'No se puede eliminar una organización con saldo activo.',
};
